import { IService } from "../common/data/dtos/service";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/Service';

interface ServiceResponse {
    success: boolean;
    service?: IService;
    services?: IService[];
    error?: string;
}

type CreateServiceType = Omit<IService, 'id'> | Partial<IService>;

const createService = async (service: CreateServiceType): Promise<ServiceResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IService>(`${BASE_PATH}`, service);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getServices = async (): Promise<ServiceResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IService>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, services: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteService = async (id: string): Promise<ServiceResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<IService>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateService = async (service: IService): Promise<ServiceResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<IService>(`${BASE_PATH}/${service.id}`, service);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    getServices,
    deleteService,
    updateService,
    createService,
};